import { makeStyles } from "@material-ui/core/styles";
import { AppLevelContext } from "qpr-base/context/AppCtx";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";

export const useStylesViewTable = makeStyles({
  tableContainer: {
    boxShadow: "none",
    borderRadius: "18px",
  },
  table: {
    minWidth: 650,
    "& .MuiTableRow-root td:not(:first-child)": {
      borderInlineStart: "1px solid #DCDEE2",
      maxWidth: "150px",
      width: "35%",
    },
    "& .MuiTableRow-root td:last-child": {
      textAlign: "center",
      width: "45px",
      maxWidth: "85px",
    },
    "& .MuiTableRow-root": {
      borderBottom: "none",
    },
    "& .MuiTableRow-root td:first-child": {
      maxWidth: "300px",
    },
    "& .MuiTableRow-root td": {
      backgroundColor: "#fbfbfc",
      borderTop: "none",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderBottom: "none",
    },
    "& tr th:not(:first-child)": {
      borderInlineStart: "1px solid #DCDEE2",
      backgroundColor: "white",
    },
  },
  moreBtn: {
    backgroundColor: "white",
    padding: "5px",
    borderRadius: "5px",
    width: "30px",
    margin: "auto",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    "&:hover": {
      background: "#3d3a4b1c",
    },
  },
  simpleMenu: {
    "& svg": {
      color: "rgb(0, 169, 163)",
      marginInlineEnd: "5px",
      width: "24px",
      height: "24px",
    },
    "& li:last-child": {
      color: "red",
    },
    "& li:last-child svg": {
      color: "red !important",
    },
    "& span": {
      fontSize: "1.4rem",
    },
  },
});
export const useStyles = (ctx: AppLevelContext) =>
  makeThemedStyles("", (theme) => ({
    pageContainer: {
      display: "flex",
      overflow: "hidden",
      height: "calc( 100vh - 150px)",
    },
    contentContainer: {
      width: "100%",
      height: "fit-content",
    },
    titleContainer: {
      display: "flex",
      justifyContent: "flex-start",
      borderBottom: "2px solid lightgray ",
      paddingBottom: "8px",
      width: "100%",
      gap: "16px",
      marginBottom: "18px",
      marginTop: "7px",
    },
    titleType: {
      background: "rgb(233, 244, 254)",
      border: "1px solid rgb(14,37,106)",
      borderRadius: "1.615em",
      color: "rgb(14,37,106)",
      fontSize: "1.485em",
      padding: "0.46em 2em",
      marginTop: "auto",
      marginBottom: "auto",
      height: "32px",
    },
    title: {
      color: "rgb(14,37,106)",
      fontSize: "20px",
    },
    pageContentWrapper: {
      paddingInlineStart: "32px",
      paddingInlineEnd: "32px",
      background: "#F2F3F6",
      gridArea: "content",
      display: "flex",
      width: "100%",
      overflowY: "auto",
      transition: "margin-inline-start .5s linear",
      "& .PageContentMenu": {
        minWidth: "100px",
      },
      "& .drawerIcon": {
        position: "absolute",
        letterSpacing: 0,
        fontWeight: "bolder",
        "& svg": {
          marginTop: "3.2em",
          marginLeft: "5px",
          width: "1.94em",
          height: "1.37em",
          color: "#105e66",
          cursor: "pointer",
        },
      },
    },
  }));

export const useSubStyles = makeThemedStyles("", (theme) => ({
  container: { marginBottom: "64px" },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  titles: {
    display: "flex",
    gap: "18px",
    fontWeight: 400,
    color: "rgb(14,37,106)",
    fontSize: "10px",
  },
  titleIcon: {
    width: "30px",
  },
  button: {
    color: "rgb(254, 254, 254)",
    textAlign: "center",
    borderRadius: "30px",
    borderWidth: "0px",
    fontSize: "1.65em",
    padding: "10px",
    width: "200px",
    cursor: "pointer",
    marginTop: "4px",
    height: "40px",
    textTransform: "none",
  },
  submitButton: {
    background: "rgb(14, 37, 106)",
    "& span": { color: "white" },
    "&:hover": {
      backgroundColor: "rgb(14, 37, 106)",
    },
  },
  disabledSubmitButton: {
    background: "rgba(168,168,168,.4)",
    "& span": { color: "white" },
  },
}));
